export enum RedirectToDetailsType {
  CREATE = 2,
  EDIT = 3,
}
